import React from 'react'
import './NewsLetter.css'
import insta_image from '../Assets/insta.png'

const NewsLetter = () => {
  return (
    <div className='newsletter'>
        <div className="news-right">
        <img src={insta_image} alt="" />
      </div>
    </div>
    
  )
}

export default NewsLetter
